export default __webpack_public_path__ + "static/media/(94).3e299ca3.jpg";